import React, { useEffect, useState } from "react";
import SearchModal from "./SearchModal";

const GlobalSearch: React.FC = () => {
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl/Cmd + K to open search
      if ((e.ctrlKey || e.metaKey) && e.key === "k") {
        e.preventDefault();
        setIsSearchModalOpen(true);
      }
      
      // Escape to close search
      if (e.key === "Escape" && isSearchModalOpen) {
        setIsSearchModalOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isSearchModalOpen]);

  // Add search button to the page for easy access
  useEffect(() => {
    const createFloatingSearchButton = () => {
      // Remove existing button if it exists
      const existingButton = document.getElementById("floating-search-button");
      if (existingButton) {
        existingButton.remove();
      }

      const button = document.createElement("button");
      button.id = "floating-search-button";
      button.innerHTML = `
        <div style="
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #FF4A17, #e63e0f);
          border-radius: 50%;
          border: none;
          box-shadow: 0 4px 12px rgba(255, 74, 23, 0.3);
          cursor: pointer;
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          color: white;
          font-size: 24px;
        " onmouseover="this.style.transform='scale(1.1)'" onmouseout="this.style.transform='scale(1)'">
          🔍
        </div>
      `;
      
      button.addEventListener("click", () => {
        setIsSearchModalOpen(true);
      });

      document.body.appendChild(button);
    };

    // Add floating search button after a delay
    const timer = setTimeout(createFloatingSearchButton, 2000);

    return () => {
      clearTimeout(timer);
      const existingButton = document.getElementById("floating-search-button");
      if (existingButton) {
        existingButton.remove();
      }
    };
  }, []);

  return (
    <SearchModal
      isOpen={isSearchModalOpen}
      onClose={() => setIsSearchModalOpen(false)}
    />
  );
};

export default GlobalSearch; 